export default {
	common: {
		noMore: '没有更多了',
		noEmpty: '必传',
		copySuccess: '复制成功',
		copyFail: '复制失败',
		search: '搜索',
		remark: '备注',
		commit: '提交',
		status: '状态',
		revoke: '撤销',
		cancel: '取消',
		confirm: '确认',
	},
	footer: {
		companyValue: '湖南奇葩乐游网络科技有限公司',
		addressValue: '长沙市芙蓉中路442号新湖南大厦事业楼1201',
		icpValue: '湘ICP备18003044号-2',
		mapValuelat: '28.207306',
		mapValuelan: '112.985214',
		telValue: '0731-85151461',
		jobValue: 'HR女士',
		jobEmailValue: `hr{'@'}7pa.com`,
		contactValue: '刘蔚',
		emailValue: `liuwei{'@'}7pa.com`
	}
}